<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="clients-create-page-title">
      {{ $t('administration.clients.create.title') }}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-client-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-client-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-client-name-label">
                  {{ $t('administration.clients.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-user-form-name"
                  type="text"
                  v-model="clientForm.name"
                  required
                  :placeholder="$t('administration.clients.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-client-cvr-label">
                  {{ $t('administration.clients.create.cvr_label') }}
                </label>
                <b-form-input
                  qid="create-client-form-cvr"
                  type="text"
                  v-model="clientForm.cvr"
                  :placeholder="$t('administration.clients.create.cvr_label')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-client-street-label">
                  {{ $t('administration.clients.create.street_label') }}
                </label>
                <b-form-input
                  qid="create-client-form-street"
                  type="text"
                  v-model="clientForm.street"
                  :placeholder="$t('administration.clients.create.street_label')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-clients-city-label">
                  {{ $t('administration.clients.create.city_label') }}
                </label>
                <b-form-input
                  qid="create-clients-form-city"
                  type="text"
                  v-model="clientForm.city"
                  :placeholder="$t('administration.clients.create.city_label')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-client-postcode-label">
                  {{ $t('administration.clients.create.postcode_label') }}
                </label>
                <b-form-input
                  qid="create-client-form-postcode"
                  type="text"
                  v-model="clientForm.postcode"
                  :placeholder="$t('administration.clients.create.postcode_label')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-clients-country-label">
                  {{ $t('administration.clients.create.country_label') }}
                </label>
                <b-form-input
                  qid="create-client-form-country"
                  type="text"
                  v-model="clientForm.country"
                  :placeholder="$t('administration.clients.create.country_label')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-partition-ref-label">
                  {{ $t('administration.partitions.create.reference_label') }}
                </label>
                <b-form-input
                  qid="create-partition-form-cvr"
                  type="text"
                  v-model="clientForm.reference_number"
                  :placeholder="$t('administration.partitions.create.reference_label')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-client-cancel-button"
              >
                {{ $t('administration.users.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        :disabled="buttonDisabled"
                        variant="success"
                        qid="create-client-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('administration.users.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateClient',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('administration.title'),
            to: '/administration'
          },
          {
            text: this.$t('administration.clients.title'),
            to: '/administration/clients'
          },
          {
            text: this.$t('administration.clients.create.title'),
            active: true
          }
        ],
        clientForm: {
          name: '',
          cvr: '',
          street: '',
          city: '',
          postcode: '',
          country: '',
          reference_number: '',
          email: ''
        },
        error: '',
        buttonDisabled: false
      }
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      }
    },
    methods: {
      goToList() {
        this.$router.push({name: 'administration.clients', params: {reload: true}})
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        piincHttp.post('clients', this.clientForm).then(function(response) {
          self.$toastr('success', self.$t('administration.clients.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },

    },
    components: {

    },
    created () {

    }
  }
</script>
